import React from "react";
import AppBar from "components/Layout/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EditIcon from "assets/img/editIcon.svg";
import DropDownIcon from "assets/img/dropdowncircule.svg";
import CashShowstock from "assets/img/cashshowstock.svg";
import FermeNo1 from "pages/Stock/StockTabs/FermeNo1";
const CashStockSheet = () => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };
  return (
    <>
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col">
        <div className="pt-4">
          <AppBar />
        </div>
        <div>
          <Box
            sx={{
              mt: 4,
              p: 1,
            }}
          >
            <Box className="feremtabn">
              <Tabs value={tabIndex} onChange={handleTabChange}>
                <Tab label="Champs N°1" />
                <Tab label="Champs N°2" />
                <Tab label="Champs N°3" />
              </Tabs>
              <Box className="datepicbyyear">
                <input type="date" />
                <img
                  src={DropDownIcon}
                  style={{ marginLeft: "5px", width: "15px" }}
                />
              </Box>
            </Box>
            <Box sx={{ padding: 2 }}>
              {tabIndex === 0 && (
                <Box>
                  <Typography>
                    <div>
                      <Box
                        className="firstcreatCreer"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          placeItems: "center",
                          p: 2,

                          bgcolor: "background.paper",
                          borderRadius: 1,
                        }}
                      >
                        <div>
                          <p style={{ margin: "0", color: "#979797" }}>
                            {" "}
                            Solde de caisse
                          </p>
                          <p
                            style={{
                              display: "flex",
                              margin: "0",
                              color: "#373737",
                            }}
                          >
                            0 CFA{" "}
                          </p>
                        </div>
                        <button className="btntag" style={{ display: "flex" }}>
                          {" "}
                          <img src={EditIcon} style={{ marginRight: "5px" }} />
                          Accueil
                        </button>
                      </Box>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #EDEDED",
                        }}
                      >
                        <table className="resumeTabels">
                          <tr>
                            <th>Date</th>
                          </tr>
                          <tr>
                            <th>Trésorerie</th>
                          </tr>
                          <tr>
                            <th>Journal de caisse</th>
                          </tr>
                          <tr>
                            <th>Champs</th>
                          </tr>
                          <tr>
                            <th>Parcelle</th>
                          </tr>

                          <tr>
                            <th>Encaissement</th>
                          </tr>
                        </table>
                        <div className="conditionshowCreat">
                          <div>
                            <img
                              src={CashShowstock}
                              style={{ margin: "10px auto" }}
                            />
                          </div>
                          <p>Vous n’avez pas créé de fiche de stock</p>
                          <p>Cliquez sur le bouton créer un fiche de stock</p>
                          <FermeNo1 />
                        </div>
                      </div>
                    </div>
                  </Typography>
                </Box>
              )}
              {tabIndex === 1 && (
                <Box>
                  <Typography></Typography>
                </Box>
              )}
              {tabIndex === 1 && (
                <Box>
                  <Typography></Typography>
                </Box>
              )}
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default CashStockSheet;
